import * as React from 'react';
import { Query } from 'react-apollo';
import styled from 'styled-components';
import cookies from 'js-cookie';

import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { RetryLink } from 'apollo-link-retry';
import { ErrorLink } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';
import { ApolloProvider as ApolloProviderInternal } from 'react-apollo';

import { CircularProgress } from './material-ui';

window.localStorage.removeItem('authToken'); // remove old unsafe auth token

const ErrorWrapper = styled.div`
	display: flex;
	align-items: center;
	pre {
		text-transform: uppercase;
		color: ${(p) => p.theme.palette.error.main};
		font-weight: bold;
	}
`;

const DisplayError = ({ error }) => (
	<ErrorWrapper>
		{error.networkError ? <pre>Keine Internetverbindung</pre> : <pre>{error.message}</pre>}
	</ErrorWrapper>
);

const LoadingWrapper = styled.div`
	display: flex;
	height: 100%;
	min-height: 40rem;
	align-items: center;
	justify-content: center;
`;

const DisplayLoader = () => (
	<LoadingWrapper>
		<CircularProgress />
	</LoadingWrapper>
);

export const WithData = ({ children, placeholder, ...props }) => (
	<Query {...props}>
		{({ loading, error, data, ...rest }) => {
			if (loading) return placeholder || <DisplayLoader />;
			if (error) return <DisplayError error={error} />;
			return children(data, rest);
		}}
	</Query>
);

const cache = new InMemoryCache();
const httpLink = new HttpLink({
	uri: 'https://api.cinuru.com',
	// uri: 'http://localhost:3000',
	credentials: 'include',
	headers: { brand: 'NONE' },
});

const requestLink = new ApolloLink((operation, forward) => {
	// set scrf token from cookie
	const csrfToken = cookies.get('_csrf');
	operation.setContext({ headers: { 'CSRF-Token': csrfToken } });
	// forward link
	return forward(operation);
});

const errorLink = new ErrorLink(({ graphQLErrors, networkError, operation }) => {
	if (graphQLErrors && graphQLErrors.find((e) => e.extensions.code === 'UNAUTHENTICATED')) {
		if (operation.operationName !== 'GetCinema') {
			client.resetStore();
			if (onAuthFail) onAuthFail();
		}
	}
	// log errors to console
	if (graphQLErrors) {
		graphQLErrors.forEach(({ message, locations, path }) =>
			// eslint-disable-next-line no-console
			console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
		);
	}
	// eslint-disable-next-line no-console
	if (networkError) console.log(`[Network error]: ${networkError}`);
});

const retryLink = new RetryLink({ delay: { initial: 500 }, attempts: { max: 10 } });

export const client = new ApolloClient({
	link: ApolloLink.from([retryLink, errorLink, requestLink, httpLink]),
	cache,
});

let onAuthFail;
export const setAuthFailCallback = (callback) => {
	onAuthFail = callback;
};

export const ApolloProvider = ({ children }) => (
	<ApolloProviderInternal client={client}>{children}</ApolloProviderInternal>
);



// WEBPACK FOOTER //
// ./src/apollo-utils.js